import type { MenuMetadataState } from 'reducers/menu-metadata/metadata'

export const getMenuMeta = (state: MenuMetadataState) => ({
  request: state.menuMetadata.request,
  menuId: state.menuMetadata.id,
  recommendationId: state.menuMetadata.recommendationId || null,
})
